/**
 * @param {ngLocation}        $location         To redirect the user to the login screen.
 * @param {ngRootScope}       $rootScope        To be able to remove the listener when the root
 *                                              scope is destroyed.
 * @param {AppEvents}         appEvents         To be able to listen for the event triggered by
 *                                              the unauthorized request.
 * @param {AuthRoutesManager} authRoutesManager To get the login screen route.
 * @param {SSOClient}         ssoClient         To delete the SSO cookie.
 * @param {AuthEvents}        AUTH_EVENTS       To get the name of the event.
 * @ngesdoc block
 * @ngmodule auth
 */
const restartAuthentication = (
  $location,
  $rootScope,
  appEvents,
  authRoutesManager,
  ssoClient,
  AUTH_EVENTS,
) => {
  'ngInject';

  // Set the listener
  const unsubscribe = appEvents.on(AUTH_EVENTS.unauthorized, () => {
    // Delete the SSO cookie.
    ssoClient.signout();
    // Redirect the user to the login.
    $location.url(authRoutesManager.login(true));
  });
  // Set the _"listener that removes the other listener"_.
  $rootScope.$on('$destroy', () => {
    unsubscribe();
  });
};

export default restartAuthentication;
